import {Component, AfterViewInit, OnInit, Input} from "@angular/core";
import {NavBarService} from "../../services/communication/navBarService";
import {StripeService} from "../../../services/data/stripe.service";
import {UrlService} from "../../../services/url.service";
import {OrderMappingService} from "../../../services/data/order-mapping.service";
import {Router} from "@angular/router";
import {NotificationsService} from "angular2-notifications";
import {ConfigurationService} from "../../../services/configuration.service";

declare const Stripe: any;

@Component({
  selector: 'stripe-order',
  template: require('./stripe-order.component.html'),
  styles: [
    require('./stripe-order.component.scss')
  ]
})
export class StripeOrderComponent implements AfterViewInit, OnInit {

  ngOnInit(): void {
  }

  stripe: any;
  elements: any;
  card: any;

  cardName: string;

  intentId: string;

  @Input('itemType') itemType: string;

  @Input('eventId') eventId: string = null;

  @Input('businessId') businessId: number;

  filling: boolean = false;
  paying: boolean = false;

  ngAfterViewInit(): void {
    let that = this;
    this.card.mount('#card-element');

    this.card.addEventListener('change', function(event) {
      if (event.error) {
        that.changeErrorText(event.error.message);
        that.paying = false;
      } else {
        that.changeErrorText('');
      }
    });

    document.querySelector('form').addEventListener('submit', function (e) {
      e.preventDefault();
      that.paying = true;

      if(that.orderMapping.isSubscription(that.itemType, null)) {
        that.createStripeToken();
      } else {
        that.openTransaction();
      }
    });

  }

  constructor(private stripeService: StripeService, private urlService: UrlService,
              private orderMapping: OrderMappingService, private router: Router,
              private notificationsService: NotificationsService, private config: ConfigurationService) {
    this.stripe = Stripe(config.getStripeAPIKey());
    this.elements = this.stripe.elements();

    this.card = this.elements.create('card', {
      style: {
        base: {
          iconColor: '#666EE8',
          color: '#31325F',
          lineHeight: '40px',
          fontWeight: 300,
          fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
          fontSize: '15px',

          '::placeholder': {
            color: '#CFD7E0',
          },
        },
      }
    });
  }


  changeErrorText(text:string) {
    let errorElement = document.getElementById('card-errors');
    errorElement.textContent = text;
  }

  activePayment() {
    this.filling = true;
  }

  createStripeToken() {
    let that = this;

    this.stripe.createToken(this.card).then(function(result) {
      if (result.error) {
        that.paying = false;
        this.notificationsService.error('Paiement', 'Une erreur est survenue dans le processus de paiement. Veuillez réessayer.');
        that.changeErrorText(result.error.message);
      } else {
        // Send the token to your server.
        that.stripeTokenHandler(result.token);
      }
    });
  }

  stripeTokenHandler(token: any) {
    this.stripeService.subscription(token.id, this.orderMapping.getAccountId(this.itemType), this.businessId).subscribe(
      info => {
        this.intentId = info.intentId;
        this.createPayment(info.clientSecret);
      },
      error => {
        this.paying = false;
        this.notificationsService.error('Paiement', 'Une erreur est survenue dans le processus de paiement. Veuillez réessayer.');
        this.changeErrorText("Une erreur est survenue. Veuillez réessayer.");
      }
    );
  }

  openTransaction() {
    this.stripeService.openTransaction(this.orderMapping.getId(this.itemType, this.eventId), this.eventId, this.businessId).subscribe(
      transaction => {
        this.intentId = transaction.stripeIntentId;
        this.createPayment(transaction.userSecret);
      },
      error => {
        this.paying = false;
        this.notificationsService.error('Paiement', 'Une erreur est survenue dans le processus de paiement. Veuillez réessayer.');
        this.changeErrorText("Une erreur est survenue. Veuillez réitérer votre demande.")
      }
    );
  }

  createPayment(clientSecret:string) {
    let that = this;

    this.stripe.handleCardPayment(
      clientSecret, this.card, {
        payment_method_data: {
          billing_details: {name: this.cardName}
        }
      }
    ).then(function (result) {
      if (result.error) {
        this.notificationsService.error('Paiement', 'Une erreur est survenue dans le processus de paiement. Veuillez réessayer.');
        that.changeErrorText(result.error.message);
        that.paying = false;
      } else {
        that.router.navigateByUrl('/order/stripe/back?intentId='+that.intentId);
      }
    });
  }

}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader?{"configFile":"tslint.json"}!./src/app/components/premium/stripe-order/stripe-order.component.ts